const CONSENT_KEY = 'kalobrate_cookie_consent';

export const CONSENT_STATES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
};

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) || CONSENT_STATES.PENDING;
  } catch {
    return CONSENT_STATES.PENDING;
  }
};

export const setConsent = (state) => {
  try {
    localStorage.setItem(CONSENT_KEY, state);
  } catch {
    // localStorage unavailable
  }
};

export const hasConsented = () => getConsent() === CONSENT_STATES.ACCEPTED;

export const isDNT = () => {
  return navigator.doNotTrack === '1' || window.doNotTrack === '1';
};

export const revokeConsent = () => {
  setConsent(CONSENT_STATES.REJECTED);
  // Remove GA cookies
  document.cookie.split(';').forEach((c) => {
    const name = c.trim().split('=')[0];
    if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('ph_')) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  });
  // Disable GA
  if (window.gtag) {
    window.gtag('consent', 'update', { analytics_storage: 'denied' });
  }
  // Disable PostHog
  if (window.posthog && window.posthog.opt_out_capturing) {
    window.posthog.opt_out_capturing();
  }
};
